export const GET_CURRICULUMNS = "GET_CURRICULUMNS";
export const GET_CURRICULUMN = "GET_CURRICULUMN";
